export default __webpack_public_path__ + "static/media/pic5-1.716a0840.jpg";